import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useProductReadContext } from '@context/ProductContext'

import { ArrowLeftRightIcon } from '@ui/icons/ArrowLeftRight.icon'

import { TickmillProductType } from '@model/TickmillProductType'

import { MenuSection } from '@shared/components/Navigation/menuSections/useMenuSections'

export const PRODUCT_SWITCH_MENU_ID = {
  CFD: 'product-cfd',
  ETD: 'product-etd',
}

export const useProductSwitchMenu = (handleProductSwitch: () => void): MenuSection => {
  const { t } = useTranslation()
  const { product } = useProductReadContext()

  return useMemo(
    () => ({
      id: 'product-switch',
      label: t('Tabs.Product Switch'),
      icon: ArrowLeftRightIcon,
      products: [TickmillProductType.CFD, TickmillProductType.ETD],
      children: [
        {
          id: PRODUCT_SWITCH_MENU_ID.CFD,
          label: 'CFD',
          onClick: product !== TickmillProductType.CFD ? handleProductSwitch : undefined,
          isSelected: product === TickmillProductType.CFD,
        },
        {
          id: PRODUCT_SWITCH_MENU_ID.ETD,
          label: 'Futures',
          onClick: product !== TickmillProductType.ETD ? handleProductSwitch : undefined,
          isSelected: product === TickmillProductType.ETD,
        },
      ],
    }),
    [t, handleProductSwitch, product]
  )
}
